<template>
  <div class="col-12 col-sm-6 col-md-4 col-lg-3">
    <router-link class="modelrange" :to="car.key.toLowerCase()">
      <transition name="fade">
        <img
          :id="car.key"
          :src="'//lib.toyota.fi/cars/grid/'+car.image"
          v-show="isLoaded"
          :alt="car.title"
          @load="loaded"
        >
      </transition>
      <div class="loader" v-show="!isLoaded">
        <i class="fa fa-circle-o-notch fa-spin fa-3x fa-fw text-red"></i>
      </div>
      <strong>{{car.template.customer_name}}</strong>
      <br>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    car: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isLoaded: false
    };
  },
  methods: {
    loaded() {
      setTimeout(() => {
        this.isLoaded = true;
      }, 500);
    }
  }
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 125px;
}
</style>
